/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './cerf-comment.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/cdk/overlay';
import * as i5 from '@angular/cdk/scrolling';
import * as i6 from '@angular/cdk/platform';
import * as i7 from '@angular/cdk/bidi';
import * as i8 from '@angular/common';
import * as i9 from '../../../../../../app/modules/cerf/components/cerf-comment/cerf-comment.component';
const styles_CerfCommentComponent:any[] = [i0.styles];
export const RenderType_CerfCommentComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CerfCommentComponent,data:{}});
function View_CerfCommentComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(1,(null as any),['\n      ','\n    ']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.getUserInitials();
    _ck(_v,1,0,currVal_0);
  });
}
function View_CerfCommentComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),6,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),3,'md-icon',[['class','mat-icon'],['role','img']],(null as any),
          (null as any),(null as any),i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(3,
          16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(4,638976,(null as any),
          0,i3.MdIcon,[i1.Renderer2,i1.ElementRef,i3.MdIconRegistry,[8,(null as any)]],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,0,['adb'])),(_l()(),i1.ɵted(-1,
          (null as any),['\n    ']))],(_ck,_v) => {
    _ck(_v,4,0);
  },(null as any));
}
export function View_CerfCommentComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),21,'div',[['class',
      'container']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,16777216,(null as any),
          (null as any),9,'div',[['class','profile-container'],['mdTooltipPosition',
              'above']],(null as any),[[(null as any),'longpress'],[(null as any),
              'touchend']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,4).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,4).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(3,16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(4,147456,(null as any),0,i3.MdTooltip,[i4.Overlay,i1.ElementRef,i5.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i6.Platform,i3.MD_TOOLTIP_SCROLL_STRATEGY,
          [2,i7.Directionality]],{position:[0,'position'],message:[1,'message']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CerfCommentComponent_1)),i1.ɵdid(7,16384,
          (null as any),0,i8.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_CerfCommentComponent_2)),
      i1.ɵdid(10,16384,(null as any),0,i8.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(13,0,(null as any),
          (null as any),7,'div',[['class','text']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(15,0,(null as any),(null as any),1,'div',[['class','message']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(16,(null as any),['\n      ','\n    '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n    '])),(_l()(),i1.ɵeld(18,0,(null as any),(null as any),
          1,'div',[['class','date']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(19,(null as any),['\n      ','\n    '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i9.CerfCommentComponent = _v.component;
    const currVal_0:any = 'above';
    const currVal_1:any = _co.getAuthorText();
    _ck(_v,4,0,currVal_0,currVal_1);
    const currVal_2:any = _co.comment.user;
    _ck(_v,7,0,currVal_2);
    const currVal_3:boolean = !_co.comment.user;
    _ck(_v,10,0,currVal_3);
  },(_ck,_v) => {
    var _co:i9.CerfCommentComponent = _v.component;
    const currVal_4:any = _co.comment.text;
    _ck(_v,16,0,currVal_4);
    const currVal_5:any = _co.getDate();
    _ck(_v,19,0,currVal_5);
  });
}
export function View_CerfCommentComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-cerf-comment',
      ([] as any[]),(null as any),(null as any),(null as any),View_CerfCommentComponent_0,
      RenderType_CerfCommentComponent)),i1.ɵdid(1,114688,(null as any),0,i9.CerfCommentComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CerfCommentComponentNgFactory:i1.ComponentFactory<i9.CerfCommentComponent> = i1.ɵccf('app-cerf-comment',
    i9.CerfCommentComponent,View_CerfCommentComponent_Host_0,{comment:'comment'},{},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/cerf/components/cerf-comment/cerf-comment.component.ngfactory.ts